import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue, {VNode} from 'vue'
import BootstrapVue from 'bootstrap-vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import App from './App'
import router from './router'
import store from "./store"
import {globalErrorModalOptions} from "@/views/components/modals/ModalOptions";

Vue.config.productionTip = false


library.add(fas, far)

//TODO: vee-validate4.0がalpha版で存在するので正式版になるタイミングでアップグレードするか考慮の必要有
import {ValidationProvider, ValidationObserver, extend, localize, setInteractionMode} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import * as customRules from '@/plugins/vee-validate/customRules'
import ja from '@/plugins/vee-validate/lang/ja';

/*https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#interaction-modes*/
//バリデーションの検証タイミング
setInteractionMode('eager')

// バリデーションルールのimport
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
//カスタムバリデーションルールのimport
Object.keys(customRules).forEach(rule => {
  extend(rule, customRules[rule]);
});

// 対象の言語のバリデーションメッセージを設定
localize('ja', ja);


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)
store.dispatch('initAction')

Vue.config.errorHandler = async (err, vm, info) => {
  await vm.$bvModal.msgBoxOk(err.message, globalErrorModalOptions(err))
  store.commit('componentState/turnLoadingOff')
  err.action()
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
  }
})
